import React, { useEffect, useRef, useState } from "react";

import { Link, useLocation } from "react-router-dom";
import style from "./homeheader.module.css";
import { useNavigate } from "react-router-dom";
import {  Dropdown, Nav, Navbar } from "react-bootstrap";

const HomeHeader = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const [active, setActive] = useState();
  const [showAboutDropdown, setShowAboutDropdown] = useState(false);
  const [expanded, setExpanded] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  const toggleSidebar = () => {
    setIsOpen(!isOpen);
  };

  const sidebarRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
        setIsOpen(false); // Close the sidebar if clicked outside
      }
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen]);
  useEffect(() => {
    setActive(location.pathname);
  }, [location]);

  useEffect(() => {
    if (isOpen) {
      document.body.classList.add("sidebar-open");
    } else {
      document.body.classList.remove("sidebar-open");
    }
  }, [isOpen]);

 

  const handleToggle = () => {
    setExpanded(!expanded);
  };

  const scrollToSection = (id) => {
    navigate(`/aboutus#${id}`);
    const section = document.getElementById(id);
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
      setShowAboutDropdown(false); // Close the dropdown after scrolling
      setIsOpen(false);
    }
  };

  return (
    <>
      <div className={style.headbaground}>
        <div className="container">
          <div className={style.headerhead}>
            <p className="mb-0">
              {" "}
              <span>24 Hour Hotline: </span>(800) 712-Help(4357)
            </p>
          </div>
        </div>
      </div>
      <div className={style.header_main}>
        <div className={style.mobilenavbar}>
          <Navbar
            expand="lg"
            expanded={expanded}
            className={style.mobilenavbar}
          >
            <Nav className={style.navbar}>
              <Link to="/">
                <img
                  className={style.header_logo}
                  src="/whitelogo.svg"
                  alt="mobilelogo"
                />
              </Link>
              <Link
                className="p-1 border-0"
                to="/forgottenwomen"
                onClick={() => setActive("/Forgotten Women")}
              >
                Who Are The Forgotten Women
              </Link>
              <Link
                className="p-1 border-0"
                to="/aboutus/"
                onClick={handleToggle}
              >
                About Us
              </Link>
              <Link
                target="_blank"
                className="p-1 border-0"
                to="https://supportafterabortion.com/resources/unraveled-roots/"
                onClick={handleToggle}
              >
                Unraveled Roots
              </Link>

              <Link
                className="p-1 border-0"
                to="/SupportMen.pdf"
                target="_blank"
                onClick={() => {
                  setActive("/SupportMen.pdf");
                  setExpanded(false);
                }}
              >
                Impact on Men
              </Link>

              {/* <Link
                className="p-1 border-0"
                to="/hbcu"
                onClick={() => setActive("/HBCU Project")}
              >
                HBCU Project
              </Link> */}
            </Nav>
          </Navbar>
        </div>

        <div className={style.smallscreennavbar}>
          <div className={style.smallhead}>
            <div>
              <Link to="/" onClick={() => setActive(1)}>
                <img
                  className={style.header_logo}
                  src="/whitelogo.svg"
                  alt="smallscreenlogo"
                />
              </Link>
            </div>
            <div></div>
          </div>

          <div>
            <Nav className={style.navbar}>
              <div
                className={`position-relative `}
                onClick={() => setShowAboutDropdown(!showAboutDropdown)}
              >
                <Link
                  className="p-1 border-0"
                  to="/aboutus/"
                  onClick={() => {
                    setActive("/aboutus/");
                  }}
                >
                  About Us
                </Link>

                <Dropdown.Menu
                  className={style.drpdwn}
                  show={showAboutDropdown}
                >
                  <Dropdown.Item
                    className={`${style.drpcontent} ${style.cursor_hand}`}
                    onClick={() => {
                      scrollToSection("coresection");
                      setShowAboutDropdown(false);
                    }}
                  >
                    Core Beliefs
                  </Dropdown.Item>
                  <Dropdown.Item
                    className={`${style.cursor_hand}`}
                    onClick={() => {
                      scrollToSection("doitsection");
                      setShowAboutDropdown(false);
                    }}
                  >
                    How We Do It
                  </Dropdown.Item>
                  <Dropdown.Item
                    className={`${style.cursor_hand}`}
                    onClick={() => {
                      scrollToSection("foundersection");
                      setShowAboutDropdown(false);
                    }}
                  >
                    About the Founder
                  </Dropdown.Item>
                  <Dropdown.Item
                    onClick={() => setShowAboutDropdown(false)}
                    as="a"
                    target="_blank"
                    href="https://supportafterabortion.com/resources/unraveled-roots/"
                  >
                    Unraveled Roots
                  </Dropdown.Item>
                </Dropdown.Menu>
              </div>

              {/* <Link className="p-1 border-0" to="/hbcu" onClick={handleToggle}>
                HBCU Project
              </Link> */}

              <Link
                className="p-1 border-0"
                to="/SupportMen.pdf"
                target="_blank"
                onClick={handleToggle}
              >
                Impact on Men
              </Link>
            </Nav>
          </div>
        </div>

        <div className={`container  ${style.bigscreen}`}>
          <Nav className={style.navbar}>
            <div>
              <Link
                to="/"
                onClick={() => setActive(1)}
                style={{ borderBottom: "0px" }}
              >
                <img
                  className={style.header_logo}
                  src="/whitelogo.svg"
                  alt="bigscreenlogo"
                />
              </Link>
            </div>

            <div>
              <img
                src="/hamburger.png"
                onClick={toggleSidebar}
                style={{ cursor: "pointer" }}
              />
            </div>
          </Nav>

          <div
            ref={sidebarRef}
            className={`${style.sidebar} ${isOpen ? style.open : ""}`}
          >
            <div className={style.mainsectionsidebar}>
              <div>
                <img
                  src="/cross.png"
                  onClick={toggleSidebar}
                  style={{ padding: "25px 0", cursor: "pointer" }}
                />
              </div>
              <div className={style.navmenus}>
                <div className={style.nav}>
                  <Link
                    className={
                      active === "/Forgotten Women/" ? style.navactive : ""
                    }
                    to="/forgottenwomen"
                    onClick={() => {
                      setActive("/Forgotten Women");
                      setIsOpen(false); // Close the sidebar
                    }}
                  >
                    Who Are The Forgotten Women
                  </Link>
                </div>
                <div
                  className={`position-relative ${style.nav}`}
                  onMouseEnter={() => setShowAboutDropdown(true)} // Open dropdown on hover
                  onMouseLeave={() => setShowAboutDropdown(false)}
                >
                  <Link
                    className={active === "/aboutus/" ? style.navactive : ""}
                    to="/aboutus/"
                    onClick={() => {
                      setActive("/aboutus/");
                    }}
                  >
                    About Us
                  </Link>

                  <Dropdown.Menu
                    className={style.drpdwn}
                    show={showAboutDropdown}
                  >
                    <Dropdown.Item
                      className={`${style.drpcontent} ${style.cursor_hand}`}
                      onClick={() => {
                        scrollToSection("coresection");
                        setShowAboutDropdown(false);
                      }}
                    >
                      Core Beliefs
                    </Dropdown.Item>
                    <Dropdown.Item
                      className={`${style.cursor_hand}`}
                      onClick={() => {
                        scrollToSection("doitsection");
                        setShowAboutDropdown(false);
                      }}
                    >
                      How We Do It
                    </Dropdown.Item>
                    <Dropdown.Item
                      className={`${style.cursor_hand}`}
                      onClick={() => {
                        scrollToSection("foundersection");
                        setShowAboutDropdown(false);
                      }}
                    >
                      About the Founder
                    </Dropdown.Item>
                    <Dropdown.Item
                      onClick={() => setShowAboutDropdown(false)}
                      as="a"
                      target="_blank"
                      href="https://supportafterabortion.com/resources/unraveled-roots/"
                    >
                      Unraveled Roots
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </div>

                {/* <div className={style.nav}>
                  <Link
                    className={
                      active === "/HBCU Project/" ? style.navactive : ""
                    }
                    to="/hbcu"
                    onClick={() => {
                      setActive("/HBCU Project");
                      setIsOpen(false); // Close the sidebar
                    }}
                  >
                    HBCU Project
                  </Link>
                </div> */}

                <div className={style.nav}>
                  <Link
                    className={
                      active === "/SupportMen.pdf" ? style.navactive : ""
                    }
                    to="/SupportMen.pdf"
                    target="_blank"
                    onClick={() => setActive("/SupportMen.pdf")}
                  >
                    Impact on Men
                  </Link>
                </div>

                <div className={style.nav}></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default HomeHeader;
